import http from '@/communication/AuthConnection'

export default async ({ commit }) => {
  try {
    const request = await http.get('/v1/report/in-progress')
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/report/in-progress/index.js